export function validateEmailAddress(email: string): boolean {
  // Very primitive email-address format check.
  const emailParts = email.split("@");
  const isEmailValid =
    emailParts !== undefined && emailParts.length === 2 && emailParts[1] !== "";
  return isEmailValid;
}
